<template>
  <div class="public">
    <div class="set-public">
      <div class="feature_row">
        <div class="description">
          请添加新的公众号后，务必联系官方管理员做相应配置开通，联系方式：
          <span class="tsep" @click="copyText(contactMaill)">{{ contactMaill }}</span>
        </div>
        <div class="btn_row">
          <el-button type="primary" @click="doctoronSubmitCode">添加公众号</el-button>
        </div>
      </div>
      <el-table
        :data="pubulcList"
        style="width: 100%"
        class="table_row"
        v-loading="tableLoading"
        :row-class-name="tableRowDisabled"
      >
        <el-table-column prop="app_name" label="公众号">
          <template slot-scope="scope">
            <div>
              {{ scope.row.app_name }}
              <span v-if="scope.row.type == 2" class="type_icon sever">服务号</span>
              <span v-else-if="scope.row.type == 1" class="type_icon subscribe">订阅号</span>
              <span v-else-if="scope.row.type == 3" class="type_icon subscribe">小程序</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="本月剩余发送条数">
          <template slot-scope="scope">
            <div v-if="scope.row.type == 2">
              {{ scope.row.send_num || '0' }}/{{ scope.row.available_num || '0' }}
            </div>
            <div v-else>
              {{ scope.row.remaining_day || '0' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="ctime" label="最近群发时间">
          <template slot-scope="scope">
            {{ scope.row.publish_time == '0' ? '-' : scope.row.publish_time || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="address" label="操作">
          <template slot-scope="scope">
            <!-- 启用状态 -->
            <template v-if="scope.row.status == 1">
              <!-- 暂时隐藏了 -->
              <!-- <el-button type="text" @click="pubicCopy(scope.row)">复制链接</el-button> -->
            </template>
            <el-button type="text" @click="changeRowStatus(scope.row)">
              {{ scope.row.status == 1 ? '禁用' : '恢复' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination_col">
        <el-pagination
          style="background-color: #ffffff"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="g_pageSizesConfig"
          :total="total"
          :page-size="form.page_size"
          :current-page="form.page_index"
          @current-change="currentChange"
          @size-change="sizeChange"
        />
      </div>
    </div>
    <el-dialog
      class="release-dialog"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :show-close="false"
      :center="true"
      width="376px"
    >
      <div>确定禁用该公众号吗？</div>
      <div class="disable">（禁用后，不可用该公众号发文、建立新文章）</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 添加公众号弹窗  -->
    <AddWechat v-if="addWechatDialogVisible" @hideDialog="addWechatDialogVisible = false" />
  </div>
</template>
<script>
// import { mapGetters } from 'vuex';
import AddWechat from './components/addWechat';
import { updateAppInfoStatusApi, getAppListApi } from '@/api/setUser';
import { awaitInterfaceResponse } from '@/utils/util';
import { mapGetters } from 'vuex';
export default {
  name: 'PublicSet',
  components: {
    AddWechat,
  },
  data() {
    return {
      addWechatDialogVisible: false, // 添加公众号设置弹窗
      tableLoading: false, // 公众号Loading
      dialogVisible: false, // 公共号禁用弹窗
      disableID: null, // 记录要下架的信息ID
      colStatus: null, // 改变弹窗文字
      contactMaill: 'TSEP_eyao@tencent.com',
      pubulcList: [],
      form: {
        page_index: 1,
        page_size: 10,
      },
      total: 0, // 总页数
    };
  },
  created() {
    const { index } = this.$route.query;
    if (!index) {
      this.g_tourl('/saas/publicSet.html?index=1', { href: true });
    }
  },
  mounted() {
    this.form.page_size = this.g_pageSizeDefault;
    awaitInterfaceResponse('enterpriseId', this)
      .then(() => {
        console.log(this.enterpriseId);
        this.getPublicList();
      })
      .catch(() => {
        this.loading = false;
        this.$message.error('无法找到enterpriseId');
      });
  },
  methods: {
    tableRowDisabled({ row }) {
      if (row.status == 2) {
        return 'disabled_table';
      }
    },
    // 扫码添加公众号
    doctoronSubmitCode() {
      this.addWechatDialogVisible = true;
    },
    // 公共号编辑
    pubicView(data) {
      this.$emit('pubicView', data);
    },
    // 复制链接
    pubicCopy(item) {
      if (item.app_url) {
        this.copyText(item.app_url, () => {
          this.$message({
            message: '公众号链接已复制',
            type: 'success',
          });
        });
      } else {
        this.$message({
          message: '暂无公众号链接',
          type: 'error',
        });
      }
    },
    // 公共号禁用用
    changeRowStatus(data) {
      if (data.status == 1) {
        // 去禁用
        this.dialogVisible = true;
        this.disableID = data.id;
        this.colStatus = 2;
      } else {
        // 去开启
        this.disableID = data.id;
        this.colStatus = 1;
        this.handleDisable();
      }
    },
    // 弹窗确定禁用按钮
    confirm() {
      if (this.colStatus === 2) {
        this.handleDisable();
      }
    },
    // 禁用恢复信息
    handleDisable() {
      this.tableLoading = true;
      const form = { id: this.disableID, status: this.colStatus };
      updateAppInfoStatusApi(form)
        .then((res) => {
          this.tableLoading = false;
          if (!Object.keys(res).length) {
            this.getPublicList(true);
            const statusData = {
              1: '启用',
              2: '禁用',
            };
            const msg = `${statusData[this.colStatus]}成功`;
            this.$message({
              message: msg,
              type: 'success',
            });
            this.dialogVisible = false;
          } else {
            this.$message({
              message: '操作失败',
              type: 'error',
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message({
            message: '操作失败',
            type: 'error',
          });
        });
    },
    // 公共号跳页
    currentChange(val) {
      this.form.page_index = val;
      this.getPublicList();
    },
    sizeChange(val) {
      this.form.page_index = 1;
      this.form.page_size = val;
      this.getPublicList();
    },
    // 获取列表数据
    getPublicList(noReset) {
      this.tableLoading = true;
      this.form.enterprise_id = String(this.enterpriseId);
      getAppListApi(this.form)
        .then((res) => {
          if (!noReset) {
            this.pubulcList = [];
          }
          this.$nextTick(() => {
            this.pubulcList = res.list;
          });
          this.tableLoading = false;
          this.total = res.total;
        })
        .catch((err) => {
          console.error(err);
          this.$message({
            message: '查询失败',
            type: 'error',
          });
          this.tableLoading = false;
        });
    },
    // 公共号编辑返回
    pubulicBack(state) {
      this.showPublicView = state;
    },
    // 点击复制
    copyText(val, cb) {
      const oInput = document.createElement('input');
      oInput.value = val;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand('Copy');
      if (!cb) {
        this.$message({
          message: '复制成功',
          type: 'success',
        });
      } else {
        cb();
      }
      oInput.remove();
    },
    // 置灰 todo
    setGary() {
      // this.$store.dispatch('setUser/setGray', this.disableID);
    },
    // 取消置灰 todo
    cancelGary() {
      // this.$store.dispatch('setUser/cancelGary', this.disableID);
    },
  },
  computed: {
    ...mapGetters('user', {
      enterpriseId: 'getEnterpriseId',
    }),
  },
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
